import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { TourTravel } from '../entities/project-tour-ontour-travel.entity';
import { getTourTravels } from './get-tour-travels.action';

type Params = {
  tourTravel: TourTravel;
};

type Result = void;

export const editTourTravel = createAppAsyncThunk(
  'projectTourOntour/editTourTravel',
  async (
    params: Params,
    { extra: { projectTourOntourGateway, snackbarGateway }, dispatch },
  ): Promise<Result> => {
    try {
      await projectTourOntourGateway.editTravel(params.tourTravel);
      await dispatch(
        getTourTravels({ sequenceId: params.tourTravel.sequenceId }),
      );
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('EditTourTravel.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('EditTourTravel.Message.error'));
}
